/**
 * Phase 3 - Polish translations module
 */
import enBase from './en.js';
import { translationsPl } from '../../utils/translations/translations.pl.js';
import { plansTranslationsPl } from '../../utils/translations/plans/plansTranslations.pl.js';

const merged = { ...enBase, ...translationsPl, ...plansTranslationsPl };
export default merged;
